<template>
    <div class="psp_logo">
        <img src="/assets/media/psp/irankish.png" width="55" height="55">
    </div>
</template>

<script>
export default {
}
</script>

<style>
</style>